import type { SaveMySystemModalRedesign } from '@ecomm/bms-components/experiments/SMSRedesign/SaveMySystemModal/schema'
import { getRudderstack } from '@ecomm/shared-window'

/**
 * Track lead email submit
 * @param submit_email_type location of the lead submission
 */
export function trackLeadSubmit(submit_email_type: string) {
  getRudderstack(r => r.track('lead_submit_email', { submit_email_type }))
}

export function trackLeadSaveQuote(
  save_quote_type: boolean,
  itemsQty: readonly {
    readonly sku: string
    readonly quantity: number
  }[]
) {
  getRudderstack(r =>
    r.track('lead_save_quote', {
      save_quote_type: save_quote_type ? 'open' : 'submit',
      products: itemsQty
    })
  )
}
